import React from "react";
import { RichTextEditor } from "@/components/ui/RichTextEditor";
import { Button } from "@/components/ui/button";
import { useFormContext } from "react-hook-form";
import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface WelcomeNotesStepProps {
  editorContent: string;
  onEditorContentChange: (value: string) => void;
}

export const WelcomeNotesStep: React.FC<WelcomeNotesStepProps> = ({ editorContent, onEditorContentChange }) => {
  const { setValue } = useFormContext();

  
  const simpleTemplateText = `<h2>Welcome to Your Exclusive Offer</h2>
<p>Lorem ipsum dolor sit amet, <strong>consectetur adipiscing elit</strong>.</p>
<p>We are delighted to welcome you to our exclusive community.</p>
<p>Sed do eiusmod tempor incididunt ut labore. <em>This premium package</em> includes all the benefits outlined in your agreement.</p>
<p>Example amounts: <strong>£00,500.00</strong> and <em>€00,000.50</em> are formatted for your reference.</p>
<br />
<hr>

<p>For any questions or assistance, please <a href="mailto:holidayownersclubplus@clublacosta.com" style="color: #2563eb; text-decoration: underline;">Holiday Owners Club Plus Team</a>.</p>`;
 

  const handleUseSimpleTemplate = () => {
    onEditorContentChange(simpleTemplateText);
    setValue("notes.welcomeEmailNotes", simpleTemplateText);
  };

  return (
    <div className="space-y-6">
      <div>
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-2">
            <label htmlFor="welcomeEmailNotes" className="block text-sm font-medium">
              Additional Notes: Offer Page
            </label>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Info className="h-4 w-4 text-muted-foreground cursor-help" />
                </TooltipTrigger>
                <TooltipContent>
                  <p>These notes appear on the landing page of the offer confirmation</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
          <div className="flex gap-2">
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={handleUseSimpleTemplate}
            >
              Simple Template
            </Button>
            {/* <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={handleUseTemplate}
            >
              Use Template
            </Button> */}
          </div>
        </div>
        <RichTextEditor
          value={editorContent || ""}
          onChange={(value) => {
            onEditorContentChange(value.trim());
            setValue("notes.welcomeEmailNotes", value.trim());
          }}
        />
      </div>
    </div>
  );
};